import {Component, Inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

export interface DeleteMessageDialogData {
  id: number;
  name: string;
}

@Component({
  selector: 'app-confirm-delete-message-dialog',
  templateUrl: './confirm-delete-message-dialog.component.html',
  styleUrls: ['./confirm-delete-message-dialog.component.scss'],
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose],
})
export class ConfirmDeleteMessageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteMessageDialogData
  ) {}
}
